export enum MainRoutes {
  /** The root page of the app which will be redirected to app route */
  root = "/",

  /** The company page of the app */
  company = "company",

  /** The about products page of the app */
  aboutProducts = "about-products",

  /** The testing impersonation page of the app. Not available on production */
  testingImpersonation = "testing-impersonation",

  /** The project page of the app */
  project = "project",

  /** The member page of the app. For backward compatibility the route is still "user" */
  member = "user",
}

export enum MemberProfileTab {
  /** The information tab of member profile page */
  memberInformation = "member-information",

  /** The companies tab of member profile page */
  companies = "companies",

  /** The projects tab of member profile page */
  projects = "projects",
}

export enum CompanyProfileTab {
  /** The company information tab of company profile page */
  companyInformation = "company-information",

  /** The groups tab of company profile page */
  groups = "groups",

  /** The projects tab of company profile page */
  projects = "projects",

  /** The members tab of company profile page */
  members = "members",

  /** The plans tab of company profile page */
  plans = "plans",

  /** The hardware licenses tab of company profile page */
  hardwareLicenses = "hardware-licenses",
}

export enum ProjectProfileTab {
  /** The project information tab of project profile page */
  projectInformation = "project-information",

  /** The plans tab of project profile page */
  plans = "plans",
}

/** All the params to use with Router */
export type RouteParams = {
  /** The id of the company */
  companyId: string;

  /** The id of the project */
  projectId: string;

  /** The ID of the member */
  memberId: string;

  /** The ID of the device */
  deviceId: string;

  /** The ID of the group */
  groupId: string;

  /** The ID of the plan */
  planId: string;

  /** The selected tab for member profile page */
  memberProfileTab: MemberProfileTab;

  /** The selected tab for company profile page */
  companyProfileTab: CompanyProfileTab;

  /** The selected tab for project profile page */
  projectProfileTab: ProjectProfileTab;
};

/** All the possible types of RouteParams */
export type RouteParamValues = RouteParams[keyof RouteParams];

/** All the query search params that can be appended to the route */
export enum QueryParams {
  /** Enable beta flag */
  enableBeta = "enableBeta",

  /** Enable dev flag */
  enableDev = "enableDev",

  /** Enable sending errors to Sentry from numbered environments or localhost */
  enableSentry = "enableSentry",
}
